import {
  BaseEntity,
  JsonApiProperty,
  JsonApiRelationship,
  JsonApiResource,
} from '../jsonapi-provider';
import type MealCategory from './meal-category';
import type MealItemAssignment from './meal-item-assignment';
import type SpecialEventMeal from './special-event-meal';

@JsonApiResource({
  type: 'meal',
})
export default class Meal extends BaseEntity {
  @JsonApiProperty({ type: 'string' }) name: string;
  @JsonApiProperty({ type: 'boolean' }) isSpecialEventMeal: boolean = false;
  season?: 'SS' | 'FW' | null = null;
  weekNumber?: string | null = null;

  @JsonApiRelationship('meal-item-assignment') mealItemAssignments: MealItemAssignment[];
  @JsonApiRelationship('special-event-meal') specialEventMeal: SpecialEventMeal | null = null;
  @JsonApiRelationship('meal-category') definedMealCategories?: MealCategory[] = undefined;

  displayName(): string {
    const parts = [];
    if (this.season != null) parts.push(this.season);
    if (this.weekNumber != null) parts.push(this.weekNumber);

    const labeledName = parts.length > 0 ? ` - ${parts.join(' ')}` : '';
    return `${this.name}${labeledName}`;
  }

  constructor(
    id?: Meal['id'],
    name: Meal['name'] = '',
    season: Meal['season'] = undefined,
    weekNumber: Meal['weekNumber'] = undefined,
    mealItemAssignments = new Array<MealItemAssignment>(),
    specialEventMeal = null
  ) {
    super();
    this.id = id;
    this.name = name;
    this.season = season;
    this.weekNumber = weekNumber;
    this.mealItemAssignments = mealItemAssignments;
    this.specialEventMeal = specialEventMeal;
  }
}
